export const CONFIG = {
    BASE_URL: process.env.REACT_APP_BASE_URL,
    FRESHDESK_WIDGET_ID: 1070000002687,
};
